import { defineMessages } from 'react-intl';

const messages = defineMessages({
  label: {
    id: 'allFeatures.genderField.label',
    defaultMessage: 'Gender',
  },
  male: {
    id: 'allFeatures.genderField.male',
    defaultMessage: 'Male',
  },
  female: {
    id: 'allFeatures.genderField.female',
    defaultMessage: 'Female',
  },
  explanationShort: {
    id: 'allFeatures.genderField.explanationShort',
    defaultMessage:
      'Health, fitness score and nutrition formulas exist only for male and female – choose the one you belong to more.',
  },
  explanationFull: {
    id: 'allFeatures.genderField.explanationFull',
    defaultMessage:
      'The health, stress, workout and activity calculations are defined worldwide only for male and female. Unfortunately we cannot offer any option other than male or female, because every calculation follows the categories of one of these two, by age, and would be wrong for any third option. Whatever you identify as, please choose the one you belong to more, so the formulas for health, nutrition, fitness score and other statistics can be applied to you.',
  },
});

export default messages;
